import axios from "@/plugins/axios"

export default {
    async verifyAuth() {
        try {
          return await axios.postData("/auth/verify-auth", {});
          
        } catch (error) {
          console.error("Error:", error);
          return { status: "unauthenticated"};
        }
      },
      async verifyAdmin() {
        try {
          return await axios.postData("/auth/verify-admin", {});
          
        } catch (error) {
          console.error("Error:", error);
          return { status: "is-not-admin"};
        }
      },
}